module.exports = "/_next/static/images/ai-expreg-demo3-a5f35141951f893d8b78d6a7abc7fc5f.jpg";